import React, {useEffect} from 'react';
import PropTypes from 'prop-types';
import SwipeableViews from 'react-swipeable-views';
import { withStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Tabs from '@material-ui/core/Tabs';
import Tab from '@material-ui/core/Tab';
import Typography from '@material-ui/core/Typography';
import Box from '@material-ui/core/Box';
import MidSpeedCombined from './MidSpeedCombined';
import MidSpeedNB from './MidSpeedNB';
import MidSpeedSB from './MidSpeedSB';


function TabPanel(props) {
    const { children, value, index, ...other } = props;

    return (
        <div
            role="tabpanel"
            hidden={value !== index}
            id={`full-width-tabpanel-${index}`}
            aria-labelledby={`full-width-tab-${index}`}
            {...other}
        >
            {value === index && (
                <Box p={3}>
                    <Typography component="div">{children}</Typography>
                </Box>
            )}
        </div>
    );
}

TabPanel.propTypes = {
    children: PropTypes.node,
    index: PropTypes.any.isRequired,
    value: PropTypes.any.isRequired,
};

function a11yProps(index) {
    return {
        id: `full-width-tab-${index}`,
        'aria-controls': `full-width-tabpanel-${index}`,
    };
}

//Start Css Code ..
const useStyles = makeStyles((theme) => ({
    root: {
        backgroundColor: theme.palette.background.paper,
        width: '100%',
        padding: '0px',
        '& .Mui-selected': {
            background: '#24618E',
            color: "#fff !important",
            fontWeight: '600',
        },
        '& .MuiTabs-root': {
            minHeight: '35px',
        },
        '& .MuiTabs-flexContainer': {
            display: 'inline-block',
        },
        '& .MuiTabs-indicator': {
            backgroundColor: 'transparent !important',
        },
        '& .MuiTab-root': {
            minWidth: '150px',
        },
        '& .PrivateTabIndicator-colorPrimary-14': {
            backgroundColor: '#24618E',
        },
        '& .MuiAppBar-colorDefault': {
            boxShadow: 'none',
            background: '#fff',
            '& .MuiButtonBase-root': {
                border: '1px solid #24618E',
                borderRadius: '6px 6px 0px 0px',
                minHeight: 'auto',
                borderBottom: 'none',
                color: "#333",
                padding: '5px 10px',
            }
        },
        '& h5': {
            fontSize: '16pt',
            margin: '0px',
        }
    },
    countsTabMain: {
        marginTop: '15px',
        height: '100%',
        width: '100%',
        float: 'left',
        background: '#fff',
        top: '2%',
        zIndex: '1',
        '& h4': {
            fontSize: '20pt',
            margin: '0',
            color: '#24618E',
            marginTop: '30px',
        },
        '& .MuiPaper-elevation2': {
            boxShadow: 'none',
        },
        '& .focus': {
            background: '#24618E',
            color: "#fff !important",
            fontWeight: '600',
        },
    }, tabblock: {
        border: '1px solid #24618E',
        paddingTop: '10px',
        marginBottom: '10px',
        borderRadius: '0px 5px 5px 5px',
        width: '100%',
        float: 'left',
        '& .MuiBox-root': {
            padding: '0px 10px 10px 10px',
        },
        '& .MuiInput-underline:after': {
            borderBottom: 'none !important',
        },
        '& .MuiInput-underline:before': {
            borderBottom: 'none !important',
        }
    },
    tempGrapImage: {
        width: '100%',
        float: 'left',
        '& img': {
            width: '85%',
        }
    },
    combinedTableBlock: {
        width: '100%',
        float: 'left',
        marginBottom: '10px',
        '& .mainDivBlock': {
            width: '60%',
            float: 'left',
            marginLeft: '10%',
        },
        '& .blockDiv': {
            width: '33.33%',
            float: 'left',
            padding: '0 30px',
        },
        '& .MuiPaper-elevation1': {
            boxShadow: 'none',
        }
    },
    tabDisable:{
        backgroundColor: '#ffffff',
        color: '#666666',
        border: '1px solid grey',
        opacity: 0.5,
        }
}));
//End Css Code ..

//Start MidBlockSpeedTab component code ...
const MidBlockSpeedTab = (props) => {
    let activeTab = sessionStorage.getItem('activeMidSpeedTab') ? parseInt(sessionStorage.getItem('activeMidSpeedTab')) : 0;
    const classes = useStyles();
    const theme = useTheme();
    const [value, setValue] = React.useState(activeTab);
    const [combineData, setCombineData] = React.useState();
    const [NBdata, setNBdata] = React.useState();
    const [SBdata, setSBdata] = React.useState();

    useEffect(() => {
        if (props.speedData) {
            setCombineData(props.speedData.combine);
            setNBdata(props.speedData.data1);
            setSBdata(props.speedData.data2);
        }

    }, [props.speedData]);
    const handleChange = (event, newValue) => {
        sessionStorage.setItem('activeMidSpeedTab', newValue);
        setValue(newValue);
    };

    const handleChangeIndex = (index) => {
        sessionStorage.setItem('activeMidSpeedTab', index);
        setValue(index);
    };

    return (
        <React.Fragment>
            <div className={classes.countsTabMain}>
                <div className={classes.root}>
                    <AppBar position="static" color="default">
                        <Tabs
                            value={value}
                            onChange={handleChange}
                            indicatorColor="primary"
                            textColor="primary"
                            variant="fullWidth"
                            aria-label="full width tabs example"
                        >
                            <Tab label="Combined" {...a11yProps(0)} id="combined_Tab" />
                            {props.getDirectionSpeedName && <Tab className={props.getDirectionSpeedName == "" ? classes.tabDisable : null} label={props.getDirectionSpeedName?props.getDirectionSpeedName:'N/A' } {...a11yProps(1)} id="nB_tab" disabled={props.getDirectionSpeedName == ""}/>}
                            {props.getDirectionSpeedNameTab && <Tab className={props.getDirectionSpeedNameTab == "" ? classes.tabDisable : null} label={props.getDirectionSpeedNameTab?props.getDirectionSpeedNameTab:'N/A' } {...a11yProps(2)} id="sb_tab" disabled={props.getDirectionSpeedNameTab == ""}/>}

                        </Tabs>
                    </AppBar>
                    <SwipeableViews
                        axis={theme.direction === 'rtl' ? 'x-reverse' : 'x'}
                        index={value}
                        onChangeIndex={handleChangeIndex}
                    >
                        <TabPanel value={value} index={0} dir={theme.direction} className={classes.tabblock}>
                            <MidSpeedCombined data={combineData}/>
                        </TabPanel>
                        <TabPanel value={value} index={1} dir={theme.direction} className={classes.tabblock}>
                            <MidSpeedNB data={NBdata}/>
                        </TabPanel>
                        <TabPanel value={value} index={2} dir={theme.direction} className={classes.tabblock}>
                            <MidSpeedSB data={SBdata}/>
                        </TabPanel>
                    </SwipeableViews>
                </div>
            </div>
        </React.Fragment>
    );
}

export default MidBlockSpeedTab;
//End MidBlockSpeedTab component code ...